export const sanitizeAmountInput = (raw: string, options: { decimalScale?: number } = {}): string => {
  if (!raw) return '';
  const { decimalScale = 2 } = options;
  let cleaned = raw.replace(/[^\d.]/g, '');
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    cleaned = `${parts[0]}.${parts.slice(1).join('')}`;
  }
  if (decimalScale === 0) {
    return cleaned.split('.')[0];
  }
  const [int, dec] = cleaned.split('.');
  if (dec === undefined) return int;
  return `${int}.${dec.slice(0, decimalScale)}`;
};

export const sanitizeInteger = (raw: string): string => raw.replace(/\D/g, '');

export const parseAmount = (raw: string): number => {
  const n = Number(raw);
  if (Number.isNaN(n) || n < 0) return 0;
  return n;
};

export const formatPhone = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const formatSsn = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};
